//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { getCurrentUser } from 'aws-amplify/auth';
//  -- Components ---------------------
import InitialLoading from "components/InitialLoading";
//  -- Features -----------------------
import BalconCulturalLayout from "features/BalconCulturalLayout";
import { filter, find, get, has } from "lodash";
import queryString from "query-string";
import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
//  -- Thunks -------------------------
import { handleListEbookData } from 'store/books/thunks';
import { handleListClassActivities , handleListClassActivitiesForStudent } from 'store/classActivities/thunks';
import { handleListClassQuizzes  , handleListClassQuizzesForStudent} from 'store/classQuizzes/thunks';
import { handleListUserSubmissionsByClass } from "store/submissions/thunks";
import { handleListUserBooks } from "store/userBooks/thunks";
import { handleListClassUsers } from "store/userClasses/thunks";
import styled from "styled-components";
//  -- Lib ----------------------------
import { useAlertView } from "store/alert/selectors";
import { useBookUnits } from "store/booksUnits/selectors";
import { useCurrentOrgPermission } from 'store/organizations/selectors';
import { ebookConfigDinamic } from "utils/lib/ebookHelper";
import { handleListInstructionByClass, handleListInstructionByUser } from "store/instructions/thunks";
import { checkBookId } from "utils/methods/math";
import { usePageTranslations } from "store/page_translations/selectors";
import { useFetchAllContent } from "components/hooks";
import { handleGetAllSlides } from "store/slides/thunk";
import { handleListChapterArticle, handleListStoryAiConfig } from "store/StoryAiCofig/thunks";
import { handleLearningModuleCount } from 'store/bingo/thunks';
import { usePDFView, useStoryView } from 'store/main_book_popup/selectors';
import SentryWrap from 'components/Sentry';
import { redirectToHome } from 'utils/config/navigation';
import { handleListGrammarContent, handleListVocabContent } from 'store/page_translations/thunks';

const CHAPTER_ID = "41";

//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------
const CenterContainer = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  min-height: 90vh;
  justify-content: center;
  width: 100%;
`;

export const Wrapper = styled.div`
  height: 100%;
  width: 100%;
`;

//  ----------------------------------------------------------------------------
//  Container
//  ----------------------------------------------------------------------------
//
//  Not found container
//
//  -- Description
//  Failed route catch container
//
//  -- Props
//  ...
//
//  -- State
//  ...
//
//  -- Methods
//  ...
//
//  -- Usage
//  ...
//
const InformateEbookContainer = ({
  currentClass,
  currentUser,
  classUsers,
  tipsBook,
  classActivities,
  classQuizzes,
  submissions,
  booksAllList,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { revokePDFView } = usePDFView();
  const { revokeStoryView } = useStoryView();
  const search = queryString.parse(location.search);
  const bookUnitList = useBookUnits()
  const UNIT_PAGES = get(find(bookUnitList,["bookId",CHAPTER_ID]),"pages",[])
  const bookData=filter(UNIT_PAGES,item=>item.id===search.id)[0]??{};
  const [ebookFlag, setEbookFlag] = useState(null);
  const [ebookFlagTeacherEdition, setEbookFlagTeacherEdition] = useState(null);
  const [loading, setLoading] = useState(true);
  const [mounted, setMounted] = useState(false);
  const [page, setPage] = useState("1");
  const book =find(booksAllList, {id: CHAPTER_ID});
  const lessonPlan  = book?.lessonPlan; 
  const SuperLesson = book?.superLesson;
  const DifferentiationLesson = book?.differentiationLesson;
  const sentenceStarterData = book?.sentence_starter_data;
  const rubrics = get(book,"rubrics",[]);
  const ai_content = get(book,"ai_content",[]);
  const assignmentPlan = book?.assignmentPlan;
  const workbook_plan = book?.workbook_plan;
  const main_book = book?.main_book;
  const [,invokeAlert,revokeALert ] =useAlertView()
  const orgPermissions = useCurrentOrgPermission()
  let dataBook = filter(booksAllList, (x) => x && x.id == CHAPTER_ID)[0] ?? {};
  const fetchPageExist = filter(get(dataBook, "pages"), x => x.pageId == search.page).length > 0;
 const { handleFetchPageTranslations } = usePageTranslations();
 const {fetchAllContent} = useFetchAllContent();

  useEffect(()=>{
      if(orgPermissions && typeof orgPermissions['1nformate']==="boolean"){
        if(!orgPermissions['1nformate']){
          invokeAlert()
          setTimeout(()=>{
            navigate(redirectToHome(currentUser) || '-1');
            revokeALert()
          },5000)
        }
      }
    },[orgPermissions])

    const disableBackWrad = (page) => {
      return parseInt(page, 10) < parseInt(bookData?.start, 10)
  }
    const disableForWard = () => {
        return parseInt(page, 10) > parseInt(bookData?.finish, 10)
    }


  useEffect(() => {
    if(Object.keys(bookData)?.length === 0){
      navigate(redirectToHome(currentUser) || '-1');
      return;
    }
    if(search.page){
        if (!fetchPageExist || checkBookId(search.page,bookData?.start) || checkBookId(search.page,bookData?.finish,10,"greaterThan")) return navigate(-1);
      setPage(search.page);
    }else{
      setPage(bookData.start??"1");
    }
   }, [bookData, search.page])
  const data = ebookConfigDinamic(
    CHAPTER_ID,
    booksAllList
  );

  const getExitTeacherEdition =React.useCallback((_page) => {
    let existTeacherEdition = false;
    if (dataBook.teacherEdition != undefined) {
      existTeacherEdition =
        filter(dataBook.teacherEdition, (x) => x.pageId == _page).length > 0;
    }
    return existTeacherEdition;
  }, [dataBook,page]);
  const getShowAnswers =React.useCallback((_page) => {
    let existShowAnswer = false;
    if (dataBook.pagesTeacher != undefined) {
       existShowAnswer = filter(dataBook.pagesTeacher, (x) => x.pageId == _page).length>0;
    }
    return existShowAnswer;
  }, [dataBook,page]);

  useEffect(() => {
    setTimeout(() => setMounted(true), 250);
    return () => {
      revokePDFView();
      revokeStoryView();
    }
  }, []);

  useEffect(() => {
    async function fetchData() {
      try {
        await getCurrentUser();
      } catch {
        navigate("/");
      }
    }
    fetchData();
  }, []);
  const listChapterData = async () => {
    //dispatch(handleListUserNotes(get(currentUser, "id")))
    dispatch(handleListEbookData(CHAPTER_ID))
  }
  const getStudentSubmissions = async () => {
    if (get(currentUser, "role") == "student") {
      // return dispatch(handleListUserSubmissions(currentUser?.id))
      return  dispatch(handleListUserSubmissionsByClass(currentUser?.id,currentClass?.id))
    }
  }
  const getBookDataForTeacher = async () => {
    if (get(currentUser, "role") === 'teacher' && has(currentClass, "id")) {
      dispatch(handleListClassUsers(get(currentClass, "id")));
    }
  }
  const listClassAssignments = async () => {
    if (has(currentClass, "id") && get(currentUser, "role") != "student") {
      dispatch(handleListClassActivities(currentClass.id));
      dispatch(handleListClassQuizzes(currentClass.id));
    } else {
      dispatch(handleListClassActivitiesForStudent(get(currentClass, "id"), get(currentUser, "id")));
      dispatch(handleListClassQuizzesForStudent(get(currentClass, "id"), get(currentUser, "id")));
    }
  }

  const fetchLearningModuleCount = async (page) => {
    if (currentUser?.role === 'student' || currentUser?.role === 'teacher') {
      dispatch(handleLearningModuleCount({
        chapter: CHAPTER_ID,
        userId: currentUser?.role === 'student' ? currentClass?.teacherId : currentUser.id,
        pageId: page,
      }));
    }
  };

  useEffect(() => {
    fetchLearningModuleCount(page);
  }, [page]);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      const islodadedOnceInformate = sessionStorage.getItem("islodadedOnceInformate");
      const currentClassId = sessionStorage.getItem("cureentClassId");
      listInstruction();
      if (
        (islodadedOnceInformate &&
          currentClassId &&
          currentClassId === currentClass?.id) ||
        (!currentClass?.id && currentClassId == "noclasssid")
      ) {
        setLoading(false);
      }
      const is_student = currentUser?.role === "student";
      const user_id = currentUser?.id;
      const class_id = currentClass?.id;
      await Promise.allSettled([
        listChapterData(),
        getStudentSubmissions(),
        getBookDataForTeacher(),
        listClassAssignments(),
        handleFetchPageTranslations(CHAPTER_ID),
        fetchAllContent(CHAPTER_ID,page),
        dispatch(handleGetAllSlides(CHAPTER_ID)),
        dispatch(handleListStoryAiConfig({chapter : CHAPTER_ID, user_id, class_id },is_student)),
        dispatch(handleListChapterArticle({chapter : CHAPTER_ID })),
        dispatch(handleListGrammarContent(CHAPTER_ID)),
        dispatch(handleListVocabContent(CHAPTER_ID)),
        // dispatch(handleListOneGameGallery()),
        // dispatch(handleListOneGameCategory("pictures_categories"))
    ])
    sessionStorage.setItem("cureentClassId", currentClass?.id ?? "noclasssid");
    sessionStorage.setItem("islodadedOnceInformate", "true");
      setLoading(false);
      dispatch(handleListUserBooks(currentUser?.id));
    }
    fetchData();
  }, [currentUser?.id, currentClass?.id, dispatch]);


  const listInstruction = async () => {
    if (has(currentUser, "id") && currentUser.role == "teacher") {
        await dispatch(handleListInstructionByUser(currentUser.id))
    }
    if (has(currentClass, "id") && currentUser.role != "teacher") {
        dispatch(handleListInstructionByClass(get(currentClass, "id")));
    }
}

  return (
    <SentryWrap>
    <Wrapper>
      {loading ? (
        <CenterContainer>
          <InitialLoading mounted={mounted} />
        </CenterContainer>
      ) : (
        <BalconCulturalLayout
          classUsers={classUsers}
          activity={search.activity??"null"}
          data={data}
          tips={tipsBook}
          existTeacherEdition={getExitTeacherEdition(page)}
          existShowAnswer={getShowAnswers(page)}
          ebookFlag={ebookFlag}
          setEbookFlag={setEbookFlag}
          ebookFlagTeacherEdition={ebookFlagTeacherEdition}
          setEbookFlagTeacherEdition={setEbookFlagTeacherEdition}
          history={navigate}
          page={page}
          setPage={setPage}
          quiz={search.quiz??"null"}
          currentUser={currentUser}
          submissions={submissions}
          classQuizzes={classQuizzes}
          classActivities={classActivities}
          id={search.id}
          bookData={bookData}
          backToLabel={'1nformate lessons'}
          CHAPTER_ID={CHAPTER_ID}
          lessonPlan={lessonPlan}
          rubrics={rubrics}
          assignmentPlan={assignmentPlan}
          workbook_plan={workbook_plan}
          main_book={main_book}
          SuperLesson={SuperLesson}
          DifferentiationLesson={DifferentiationLesson}
          chapter={CHAPTER_ID}
          ai_content={ai_content}
          book={book}
        />
      )}
    </Wrapper>
    </SentryWrap>
  );
};


//  ----------------------------------------------------------------------------
//  Redux
//  ----------------------------------------------------------------------------
const mapStateToProps = (state) => ({
  currentClass: state.currentClass,
  currentUser: state.currentUser,
  classUsers: state.classUsers,
  tipsBook: state.tipsBook,
  classActivities: state.classActivities,
  classQuizzes: state.classQuizzes,
  submissions: state.submissions,
  booksAllList: state.booksAllList,
});

export default connect(mapStateToProps, null)(InformateEbookContainer);
